<template>
  <div class="select-xg-toast" v-show="show">
    <div class="sl-bg" @click="hideSelect"></div>
    <div class="select-page">
      <div class="slc-hd">
        <div class="ti">选择学校</div>
        <span class="icon iconfont icon-guanbi" @click="hideSelect"></span>
      </div>
      <div class="select-list" ref="wrapper">
        <div class="select-wrap">
          <div class="area" v-for="(item, key) of cities" :key="key" :ref="key">
            <div class="title">{{ key }}</div>
            <div class="item-list">
              <div
                class="item"
                v-for="innerItem of item"
                :key="innerItem.id"
                @click="handleCityClick(innerItem.id)"
              >
                {{ innerItem.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <school-alphabet
        :cities="cities"
        @change="handleLetterChange"
      ></school-alphabet>
    </div>
  </div>
</template>

<script>
import SchoolList from "./list";
import SchoolAlphabet from "./Alphabet";
import Bscroll from "better-scroll";
import { Loading, Message, MessageBox } from "element-ui";
let loading;
let loadingCount = 0;
function start() {
  loading = Loading.service({
    lock: true,
    text: "跳转中",
    background: "rgba(0,0,0,0.7)",
  });
}
function end() {
  loading.close();
}
function showLoaing() {
  if (loadingCount == 0) {
    start();
  }
  loadingCount++;
}

function hideLoading() {
  loadingCount--;
  if (loadingCount == 0) {
    end();
  }
}
export default {
  name: "SelectSchool",
  components: {
    SchoolList,
    SchoolAlphabet,
  },
  props: {
    cities2: Object,
    letter2: String,
  },
  data: function () {
    return {
      show: true,
      cities: {   },
      letter: "",
    };
  },
  methods: {
    handleLetterChange(letter) {
      this.letter = letter;
      // console.log(letter)
    },
    hideSelect() {
      //this.show = false;
      //window.location.href="/login";
      this.$router.push("/login");
      // this.$message({
      //   message: '必须选择学校！',
      //   type: 'error'
      // });
    },
    handleCityClick: function (city) {
      showLoaing();
      this.$bti.GetOrgInfoBySchoolCode({ schoolCode: city }).then((res) => {
        if(res.code != 1) {
          window.location.href = window.location.href;
          return;
        }
        var url = res.data.URL.slice(0,res.data.URL.lastIndexOf(':'))
        var domain = ""
        if (url === 'http' || url === 'https') {
            domain = res.data.URL
        }else{
            domain = url + ":" + this.$bti.MobilePort
        }
        console.log(url.endsWith("/"))
        this.$bti.GoRegister({schoolId: city, schoolname: "", domain: domain, TERMINALTYPE: "2",}).then((result) => {
          var rout = res.data.URL
          if(result.code != 1) {
            if (rout.endsWith("/")) {
              window.location.href = rout + "Register?position=" + res.data.ID;
            }else{
              window.location.href = rout + "/Register?position=" + res.data.ID;
            }
            return;
          }
          if (result.data == "Interface") {
            if (rout.endsWith("/")) {
              window.location.href = rout + "Register?position=" + result.data;
            }else{
              window.location.href = rout + "/Register?position=" + res.data.data;
            }
            return;
          }
          // console.log(result.data.ResultUrl + "&ResultUrl=" + encodeURIComponent(encodeURIComponent(result.data.ReturnUrl)))
          window.location.href = result.data.ResultUrl + "&ResultUrl=" + encodeURIComponent(encodeURIComponent(result.data.ReturnUrl));
        });
      });
    },
    getSchoolList() {
      this.$bti.GetSchoollist({}).then((result) => {
          var res = result.data;
          if (result.code==1) {
            let obj = {};
            for (let i = 0; i < res.letter.length; i++) {
              let arrays2 = [];
              for (let z = 0; z < res.schoolList.length; z++) {
                if (res.letter[i] == res.schoolList[z].spell) {
                  arrays2.push(res.schoolList[z]);
                }
              }
              const keyName = res.letter[i];
              this.$set(obj, keyName, arrays2);
            }
            this.cities = obj;
            //console.log(this.cities);
            this.$nextTick(() => {
              this.scroll = new Bscroll(this.$refs.wrapper, {
                click: true,
                mouseWheel: true, //鼠标滚轮滚动
              });
            });
          }
        });
    },
  },
  watch: {
    letter() {
      if (this.letter) {
        const element = this.$refs[this.letter][0];
        this.scroll.scrollToElement(element);
      }
      // console.log(this.letter)
    },
  },
  mounted() {
    this.getSchoolList();
    //console.log(this.$refs.wrapper)
    if (this.$route.query.position != "" && this.$route.query.position != undefined) {
      this.show = false;
    }
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/account/SelectSchool.vue